import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const ProtectedRoute = ({ element, requiredRole }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  useEffect(() => {
    const validateToken = () => {
      // Check for owner token first
      const ownerToken = localStorage.getItem('ownerToken');
      // Check for retailer token if owner token doesn't exist
      const retailerToken = localStorage.getItem('retailerToken');
      
      // No tokens found
      if (!ownerToken && !retailerToken) {
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }
      
      try {
        let decodedToken;
        let userRole;
        
        // Determine which token to use based on the required role
        if (requiredRole === 'owner' && ownerToken) {
          decodedToken = jwtDecode(ownerToken);
          userRole = 'owner';
        } else if (requiredRole === 'retailer' && retailerToken) {
          decodedToken = jwtDecode(retailerToken);
          userRole = 'retailer';
        } else if (!requiredRole) {
          // If no specific role is required, check both tokens
          decodedToken = ownerToken ? jwtDecode(ownerToken) : jwtDecode(retailerToken);
          userRole = ownerToken ? 'owner' : 'retailer';
        } else {
          // Required role doesn't match available tokens
          setIsAuthenticated(false);
          setIsLoading(false);
          return;
        }
        
        // Check token expiration
        if (decodedToken.exp * 1000 < Date.now()) {
          // Remove expired token
          if (userRole === 'owner') {
            localStorage.removeItem('ownerToken');
          } else {
            localStorage.removeItem('retailerToken');
          }
          setIsAuthenticated(false);
          setIsLoading(false);
          return;
        }
        
        // Validate role if required
        if (requiredRole && userRole !== requiredRole) {
          setIsAuthenticated(false);
          setIsLoading(false);
          return;
        }
        
        setIsAuthenticated(true);
        setIsLoading(false);
      } catch (error) {
        // Invalid token
        localStorage.removeItem('ownerToken');
        localStorage.removeItem('retailerToken');
        setIsAuthenticated(false);
        setIsLoading(false);
      }
    };
    
    validateToken();
  }, [requiredRole]);
  
  if (isLoading) {
    return <div className="loading-container">Loading...</div>; // Or your loading component
  }
  
  // Redirect to appropriate login page based on required role
  if (!isAuthenticated) {
    if (requiredRole === 'owner') {
      return <Navigate to="/Owner-Home" />;
    } else if (requiredRole === 'retailer') {
      return <Navigate to="/Retailer-Home" />;
    } else {
      return <Navigate to="/" />;
    }
  }
  
  return element;
};

export default ProtectedRoute;